const plans = [
  {
    label: "パッケージS",
    badge: ["キャンペーン限定", "製造業特化"],
    price: "50万円 / 1週間",
    priceBefore: "100万円",
    special: true,
    cases: [
      {
        industry: "製造業",
        title: "Excelの案件管理をWebアプリ化",
        desc: "Excelで管理していた案件情報をWebアプリ化。一覧表示・検索・進捗管理まで、複数拠点からリアルタイムで共有できます。",
        result: "確認・検索作業を大幅削減",
      },
      {
        industry: "製造業",
        title: "納期アラートの自動通知",
        desc: "納期が近い案件・超過した案件を毎朝メールやチャットツールで自動通知。確認漏れを防ぎます。",
        result: "納期漏れゼロ",
      },
      {
        industry: "製造業",
        title: "得意先・担当者の一元管理&帳票出力",
        desc: "得意先・担当者・工場の情報をまとめて管理。発注書もワンクリックで出力できます。",
        result: "書類作成を効率化",
      },
    ],
  },
  {
    label: "パッケージA",
    price: "100万円 / 1週間",
    special: false,
    cases: [
      {
        industry: "製造業",
        title: "日報・検査記録の自動整理ダッシュボード",
        desc: "紙やExcelで管理している日報・検査記録をAIが自動で整理・検索。現場のトラブル事例をすぐに探せるようにします。",
        result: "紙・Excel管理からの脱却",
      },
      {
        industry: "金融・保険",
        title: "書類分類・要約AIプロトタイプ",
        desc: "申請書類をAIが自動分類・要約し、審査担当者の初期判断を支援。",
        result: "審査前処理50%短縮",
      },
      {
        industry: "小売・EC",
        title: "商品問い合わせAIチャットボット",
        desc: "FAQ・在庫状況の自動応答。カスタマーサポートの一次対応を自動化。",
        result: "問い合わせ40%自動化",
      },
    ],
  },
  {
    label: "パッケージB",
    price: "200万円 / 2週間",
    special: false,
    cases: [
      {
        industry: "不動産・建設",
        title: "物件情報AI自動マッチングシステム",
        desc: "顧客要望と物件データをAIがマッチング。営業担当の物件提案を効率化。",
        result: "提案精度向上",
      },
      {
        industry: "人事・HR",
        title: "社内ナレッジ検索AIアシスタント",
        desc: "社内文書・マニュアルをRAGで横断検索。新人オンボーディングと日常業務の問い合わせを削減。",
        result: "検索時間70%削減",
      },
      {
        industry: "物流・サプライチェーン",
        title: "入出荷・配送状況モニタリング画面",
        desc: "倉庫の入出荷情報と配送ステータスを一覧できる画面を構築し、状況確認のための電話・メール対応を減らします。",
        result: "問い合わせ対応時間を削減",
      },
    ],
  },
];

export default function UseCases() {
  return (
    <section className="bg-white py-14">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">活用イメージ — 業界 × プラン別</h2>
          <p className="text-gray-500 text-sm">AI活用開発で、こんなプロダクトを開発できます</p>
        </div>

        {plans.map((plan) => (
          <div key={plan.label} className="mb-12">
            <div className={`flex flex-wrap items-center gap-3 mb-5 pb-4 border-b ${plan.special ? "border-amber-300" : "border-gray-200"}`}>
              <span className={`text-base font-extrabold ${plan.special ? "text-amber-600" : "text-gray-800"}`}>
                {plan.label}
              </span>
              {plan.priceBefore && (
                <span className="text-gray-400 line-through text-sm">{plan.priceBefore}</span>
              )}
              <span className={`font-bold text-sm ${plan.special ? "text-amber-600" : "text-gray-600"}`}>
                {plan.price}
              </span>
              {plan.badge?.map((b) => (
                <span
                  key={b}
                  className={`text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap ${
                    b === "キャンペーン限定" ? "bg-amber-400 text-white" : "bg-orange-500 text-white"
                  }`}
                >
                  {b}
                </span>
              ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {plan.cases.map((c) => (
                <div key={c.title} className="bg-gray-50 border border-gray-100 rounded-2xl p-6 hover:border-blue-200 transition-colors">
                  <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
                    {c.industry}
                  </span>
                  <h3 className="text-sm font-bold text-gray-900 mb-2 leading-snug">{c.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed mb-4">{c.desc}</p>
                  <div className="bg-blue-50 border border-blue-100 rounded-lg px-3 py-2">
                    <span className="text-xs font-bold text-blue-700">{c.result}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
